<template>
  <svg viewBox="0 0 48 48" aria-hidden="true" class="monkey-tool-icon">
    <!-- A peanut in its shell: two lobes with a waist and the shell's net of ribs. -->
    <g v-if="tool === 'peanut'" transform="rotate(-35 24 24)">
      <path
        d="M24 5C30 5 33.5 9.5 33.5 14.5C33.5 18.5 31 20.5 31 24C31 27.5 33.5 29.5 33.5 33.5C33.5 38.5 30 43 24 43C18 43 14.5 38.5 14.5 33.5C14.5 29.5 17 27.5 17 24C17 20.5 14.5 18.5 14.5 14.5C14.5 9.5 18 5 24 5Z"
        fill="#dcae72"
        stroke="#5e3b1a"
        stroke-width="2.2"
      />
      <g fill="none" stroke="#a8743c" stroke-width="1.3" stroke-linecap="round">
        <path d="M17.5 12.5Q24 14.5 30.5 12.5M16.5 17.5Q24 19.5 31.5 17.5" />
        <path d="M17.5 30.5Q24 32.5 30.5 30.5M17 36Q24 38 31 36" />
        <path d="M21 7.5Q19.8 14 21 21M27 7.5Q28.2 14 27 21" />
        <path d="M21 27Q19.8 34 21 40.5M27 27Q28.2 34 27 40.5" />
      </g>
      <ellipse cx="19.5" cy="11.5" rx="1.8" ry="3.4" fill="#f6dcb0" />
    </g>
    <!-- A ripe banana: a yellow crescent with a shaded underside, a stalk and a dark tip. -->
    <g v-else-if="tool === 'banana'">
      <path
        d="M7.6 10.8 6.2 4.4 10.4 3.4 12.2 9.9Z"
        fill="#7a6a2c"
        stroke="#3f3412"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path
        d="M8.6 10C7.6 27 19.5 39.5 38.6 37.8C41.6 37.5 42.4 35.4 41.2 33.8C27.2 34.2 17.6 25.2 14.8 10.6C14.2 7.9 8.7 7.6 8.6 10Z"
        fill="#f7d43c"
        stroke="#6e5310"
        stroke-width="2.2"
        stroke-linejoin="round"
      />
      <path
        d="M10.8 17C12.6 28.2 21.8 36 36.2 35.9"
        fill="none"
        stroke="#dca21d"
        stroke-width="2.6"
        stroke-linecap="round"
      />
      <path
        d="M13.6 13.4C15.6 21.6 20.6 27.8 28.4 31"
        fill="none"
        stroke="#fff3a6"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <circle cx="40.6" cy="35.4" r="1.9" fill="#3b2a14" />
    </g>
    <!-- A wooden stick, tip at the top left where it hits, with knots and a leafy twig. -->
    <g v-else stroke-linecap="round">
      <path d="M6 6 42 42" stroke="#4a2c12" stroke-width="7" />
      <path d="M6 6 42 42" stroke="#9c6b3a" stroke-width="4" />
      <path d="M8.5 7.5 40 39" stroke="#c99a64" stroke-width="1.3" />
      <path d="M24.5 24.5 31.5 13" stroke="#4a2c12" stroke-width="3.6" />
      <path d="M24.5 24.5 31.5 13" stroke="#9c6b3a" stroke-width="1.8" />
      <path
        d="M31 13.5C31.5 8.5 35 5.5 40.5 5.5C40.5 11 37 14 31 13.5Z"
        fill="#6db33f"
        stroke="#2f6a1b"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path d="M31.5 13 37.5 8" stroke="#2f6a1b" stroke-width="1" />
      <ellipse cx="17" cy="17" rx="2" ry="1.3" transform="rotate(45 17 17)" fill="#4a2c12" />
      <ellipse
        cx="33.5"
        cy="33.5"
        rx="2"
        ry="1.3"
        transform="rotate(45 33.5 33.5)"
        fill="#4a2c12"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import type { MonkeyTool } from "@/mascot/monkey-tools"

/** What the user holds instead of the mouse pointer; the hand is the ordinary pointer. */
defineProps<{ tool: Exclude<MonkeyTool, "hand"> }>()
</script>

<style scoped>
.monkey-tool-icon {
  width: 100%;
  height: 100%;
  overflow: visible;
}
</style>
